import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
    ADVANCED_VIZ_TYPE,
    AGGREGATION_TYPE,
    PYRAMID_VIZ_TYPE,
} from 'business/constants';
import { VizType } from 'business/definitions';
import { capitalize } from 'helpers/helpers';
import vizInfos from 'helpers/vizInfos';
import { useGetAvailableMetrics } from 'routes/Explore/components/Sentence/hooks/available';
import { orderElementsPerColumn } from '../helpers/helpers';
import { getAvailableFunctionsFromMetrics } from '../../helpers/helpers';
import { IndicatorFilterT } from '../../helpers/types';

export const useGetFilterCategories = (): {
    aggregationFilters: IndicatorFilterT<Aggregation>[];
    vizTypeFilters: IndicatorFilterT<VizType>[];
    integrationFilters: IndicatorFilterT<string>[];
} => {
    const { t } = useTranslation();

    const aggregationFilters = Object.values(AGGREGATION_TYPE).map(
        (aggregationType) => ({
            value: aggregationType,
            name: capitalize(
                t(`sentence:metricAggregations.${aggregationType}`),
            ),
        }),
    );

    const vizTypeFilters = orderElementsPerColumn(
        Object.keys(vizInfos).filter(
            (vizType) =>
                ![ADVANCED_VIZ_TYPE, PYRAMID_VIZ_TYPE].includes(vizType),
        ),
    ).map((vizType) => ({
        value: vizType,
        name: t(`settings.${vizType}`),
    }));

    const { data: availableMetrics } = useGetAvailableMetrics({});
    const availableFunctions = useMemo(
        () => getAvailableFunctionsFromMetrics(availableMetrics),
        [availableMetrics],
    );
    const integrationFilters = availableFunctions
        .map((func) => ({
            value: func,
            name: t(`cellar.${func}`),
        }))
        .sort((a, b) => a.name.localeCompare(b.name));

    return {
        aggregationFilters,
        vizTypeFilters,
        integrationFilters,
    };
};
